<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -is-open -extra-width">
  <div class="esf-main-sidebar__content">
    <h3 i18n='New contact heading for contact modal@@customerOverviewComponent.modalTitle.editContact'>Edit Contact</h3>
    <p>{{ dateToday | date:'dd.LL.yyyy' }}</p>
    <form (ngSubmit)="updateContact()" [formGroup]="updateContactForm" id="updateContactForm">
      <div app-form-field-text-generic
           [control]="updateContactForm.get('title')"
           [placeholder]="flTranslations.i18nTitle"
           [label]="flTranslations.i18nTitle">
      </div>
      <div app-form-field-textarea
           [control]="updateContactForm.get('comment')"
           [label]="flTranslations.i18nComment">
      </div>
      <div app-form-field-toggle
           [control]="updateContactForm.get('important')"
           [label]="flTranslations.i18nImportant">
      </div>
    </form>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open -extra-width">
  <app-submit-row-buttons [form]="'updateContactForm'"
                          [isFieldValid]="!customer.isDuplicate && updateContactForm.valid"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          (cancelButton)="customerOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space  -has-transition -is-open"
     (click)="customerOverviewService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
